{
  "aiGeneratedAnswer": "AI ģenerēta atbilde",
  "allCategories": "Visas kategorijas",
  "appliedFiltersToCurrentSearch": "Pielietotie filtri pašreizējai meklēšanai",
  "apply": "Pielietot",
  "applyFilters": "Pielietot filtrus",
  "autocompleteOptionsFound_one": "Atrasta {{count}}{{label}} automātiskās aizpildes iespēja.",
  "autocompleteOptionsFound_other": "Atrastas {{count}}{{label}} automātiskās aizpildes iespējas.",
  "autocompleteOptionsFound_zero": "Nav atrasta neviena{{label}} automātiskās aizpildes iespējas.",
  "autocompleteSuggestion": "automātiskās pabeigšanas ieteikums: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "Atrasts {{count}} automātās aizpildes ieteikums.",
  "autocompleteSuggestionsFound_other": "Atrasti {{count}} automātiskās aizpildes ieteikumi.",
  "autocompleteSuggestionsFound_zero": "Atrasti {{count}} automātiskās aizpildes ieteikumi.",
  "basedOnYourDevice": " (balstoties uz jūsu ierīci)",
  "basedOnYourInternetAddress": " (balstoties uz jūsu interneta adresi)",
  "categoriesText_one": "Nākamā kategorija deva rezultātus priekš – <strong>{{query}}</strong>",
  "categoriesText_other": "Nākamo kategoriju skaits deva rezultātus priekš – <strong>{{query}}</strong>",
  "categoriesText_zero": "Nav neviena rezultāta kategorijai – <strong>{{query}}</strong>",
  "clearAll": "Notīrīt visu",
  "clearMinAndMax": "Notīrīt min un max",
  "clearTheRangeToSelectOptions": "Notīriet diapazonu, lai izvēlētos opcijas.",
  "clearTheSearchBar": "Notīriet meklēšanas joslu",
  "conductASearch": "Veikt meklēšanu",
  "currentLocation": "Pašreizējā atrašanās vieta",
  "didYouMean": "Vai jūs domājāt <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Kad ir pieejami automātiskās pabeigšanas rezultāti, izmantojiet bultiņas uz augšu un leju, lai pārlūkotu, un Enter, lai izvēlētos.",
  "feedback": "Atsauksmes",
  "filterGroupSearchInputLabel": "Meklēt {{title}} opcijās",
  "invalidRange": "Nederīgs diapazons",
  "max": "Maks",
  "min": "Min",
  "navigateToTheNextResultsPage": "Dodieties uz nākamo rezultātu lapu",
  "navigateToThePreviousResultsPage": "Dodieties uz iepriekšējo rezultātu lapu",
  "noAutocompleteOptionsFound": "Atrasta 0 automātiskās pabeigšanas opcija.",
  "noAutocompleteSuggestionsFound": "Atrasti 0 automātiskās pabeigšanas ieteikumi.",
  "noResultsFoundIn": "Rezultāti nav atrasti {{currentVerticalLabel}}.",
  "paginationPage": "{{pageNumber}}. lapa",
  "pagination": "Lappuļošana",
  "readMoreAbout": "Lasīt vairāk par <a>{{name}}</a>",
  "recentSearch": "nesenā meklēšana: {{query}}",
  "recentSearchesFound_one": "Atrasta {{count}} nesenā meklēšana.",
  "recentSearchesFound_other": "Atrastas {{count}} nesenās meklēšanas.",
  "recentSearchesFound_zero": "Atrastas {{count}} nesenās meklēšanas.",
  "removeFilter": "Noņemt filtru: „{{displayName}}“",
  "resultPreview": "rezultāta priekšskatījums: {{value}}",
  "resultPreviewsFound_one": "Atrasts {{count}} rezultātu priekšskatījums.",
  "resultPreviewsFound_other": "Atrastas {{count}} rezultātu priekšskatījumi.",
  "resultPreviewsFound_zero": "Atrastas {{count}} rezultātu priekšskatījumi.",
  "resultsCountText_one": "{{count}} rezultāts",
  "resultsCountText_other": "{{count}} rezultāti",
  "resultsCountText_zero": "{{count}} rezultātu",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} no {{resultsCount}} rezultātiem",
  "searchHere": "Meklēt šeit…",
  "showingAllInstead": "Tiek rādīti visi {{currentVerticalLabel}}.",
  "showLess": "Rādīt mazāk",
  "showMore": "Rādīt vairāk",
  "sources_one": "Avots",
  "sources_other": "Avoti ({{count}})",
  "sources_zero": "Avoti nav pieejami",
  "submitSearch": "Iesniegt meklēšanu",
  "suggestionResultsCount_one": "{{label}} – {{count}} rezultāts",
  "suggestionResultsCount_other": "{{label}} – {{count}} rezultātu",
  "suggestionResultsCount_zero": "{{label}} – nav rezultātu",
  "thankYouForYourFeedback": "Paldies par jūsu atsauksmēm!",
  "thisAnsweredMyQuestion": "Šis atbildēja uz manu jautājumu",
  "thisDidNotAnswerMyQuestion": "Šis neatbildēja uz manu jautājumu",
  "unselectAnOptionToEnterInARange": "Atceļiet izvēli, lai ievadītu diapazonu.",
  "updateYourLocation": "Atjauniniet savu atrašanās vietu",
  "useCurrentLocation": "Izmantot pašreizējo atrašanās vietu",
  "useMyLocation": "Izmantot manu atrašanās vietu",
  "viewAll": "Skatīt visu",
  "viewDetails": "Skatīt informāciju"
}
